class priceTypeService {

    constructor($http, SnackbarService, translateService) {
        'ngInject';

        this.$http = $http;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;
        this.priceType = null;
        this.saving = false;
    }

    setPriceType(priceType) {
        this.priceType = priceType === 'net' ? priceType : 'gros';
    }

    savePriceType(priceType) {
        this.saving = true;
        this.$http.post(
            `/ajax/users/setPriceType`, {priceType: priceType}
        ).then(
            (response) => {
                this.priceType = response.data;
                this.saving = false;
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
                this.saving = false;
            });
    }

    isNet() {
        return this.priceType === 'net';
    }

    isGros() {
        return !this.isNet();
    }
}

export default priceTypeService;
